export default __webpack_public_path__ + "media/flavours/glitch/images/mbstobon-ui-2.png";